import { cn } from "@/lib/utils";

interface LoadingSkeletonProps {
  className?: string;
}

// General purpose loading skeleton component
export const LoadingSkeleton = ({ className }: LoadingSkeletonProps) => (
  <div className={cn("animate-pulse bg-muted rounded", className)} />
);
export const ProductCardSkeleton = () => (
  <div className="border border-border/40 rounded-lg p-6 animate-pulse bg-card">
    <div className="aspect-square rounded-md bg-muted mb-4"></div>
    <div className="space-y-3">
      <div className="h-5 bg-muted rounded w-3/4"></div>
      <div className="h-4 bg-muted rounded w-1/2"></div>
      <div className="h-5 bg-muted rounded w-1/3"></div>
    </div>
  </div>
);

export const ProductListSkeleton = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
    {Array.from({ length: 6 }).map((_, i) => (
      <ProductCardSkeleton key={i} />
    ))}
  </div>
);

export const OrderItemSkeleton = () => (
  <div className="flex items-center justify-between border border-border/40 rounded-lg p-6 animate-pulse bg-card">
    <div className="space-y-3 flex-1">
      <div className="h-5 bg-muted rounded w-32"></div>
      <div className="h-4 bg-muted rounded w-48"></div>
    </div>
    <div className="h-6 bg-muted rounded w-20"></div>
  </div>
);

export const OrderListSkeleton = () => (
  <div className="rounded-lg border border-border/40 bg-card divide-y divide-border/40">
    {Array.from({ length: 4 }).map((_, i) => (
      <div key={i} className="p-6 animate-pulse">
        <div className="flex items-center justify-between">
          <div className="space-y-3">
            <div className="h-5 bg-muted rounded w-28"></div>
            <div className="h-4 bg-muted rounded w-44"></div>
          </div>
          <div className="h-6 bg-muted rounded w-24"></div>
        </div>
      </div>
    ))}
  </div>
);

export const PageHeaderSkeleton = () => (
  <div className="animate-pulse space-y-4">
    <div className="h-10 bg-muted rounded w-64"></div>
    <div className="h-5 bg-muted rounded w-96"></div>
  </div>
);

// Make LoadingSkeleton the default export for convenience
export default LoadingSkeleton;